
const { store, ActionCreators, EventTypes } = __app__;


const CSS_CLASSES = {
	'ELEMENT': 'action-icon--cart',
	'COUNTER': 'action-icon__counter',
	'WITH_COUNTER_MODIFIER': 'action-icon--with-counter',
};

class CartIcon
{
	constructor(element)
	{
		this.element = element;

		this.counter = this.element.querySelector(`.${CSS_CLASSES.COUNTER}`);
		if (!this.counter)
		{
			this.counter = document.createElement('div');
			this.counter.classList.add(CSS_CLASSES.COUNTER);
			this.element.appendChild(this.counter);
		}
		
		store.subscribe(EventTypes.STATE_UPDATED, () => this.updateCounter());
		store.subscribe(EventTypes.CART_UPDATED, () => this.updateCounter());
	}

	updateCounter()
	{
		const quantity = store.state.cart.addedIds.size;

		this.counter.innerHTML = quantity;
		if (quantity > 0)
			this.element.classList.add(CSS_CLASSES.WITH_COUNTER_MODIFIER);
		else
			this.element.classList.remove(CSS_CLASSES.WITH_COUNTER_MODIFIER);
	}
}

document.addEventListener('DOMContentLoaded', () => {
	[...document.querySelectorAll(`.${CSS_CLASSES.ELEMENT}`)].forEach(element => new CartIcon(element));
})
